export default __webpack_public_path__ + "static/HZH_GVR_lifter-63f613126cd6d882b0839171bcf299fa.png";